fx.ns("repositories", class GoogleRepository extends fx.ModelArray {

	constructor() {
		super([]);
	}

	get currentAlbum() {
		let currentAlbum = [];

		for (let i = 0; i < this.length; i++) {
			if (this.getItemAt(i).isActive)
				currentAlbum.push(this.getItemAt(i));
		}

		return currentAlbum[0];
	}

	get selectedPhotos() {
		let selectedItems = [];

		for (let i = 0; i < this.length; i++) {
			let albumPhotos = this.getItemAt(i).photos;

			for (let j = 0; j < albumPhotos.length; j++) {
				if (albumPhotos.getItemAt(j).selected)
					selectedItems.push(albumPhotos.getItemAt(j));
			}
		}

		return selectedItems;
	}

	addAlbum(rawAlbum) {
		let album = new fx.ModelArray();
		album.addItem(rawAlbum);
		this.addItem(album);

	}

	addPhoto(album, rawPhoto) {
		if (!album.photos)
			album.photos = new fx.ModelArray([]);

		album.photos.addItem(rawPhoto);
	}

	selectAllCurrentAlbumPhotos() {
		if (!this.currentAlbum) return;

		let currentAlbumPhotos = this.currentAlbum.photos;

		for (let i = 0; i < currentAlbumPhotos.length; i++) {
			currentAlbumPhotos.getItemAt(i).selected = true;
		}
	}

	unSelectAllCurrentAlbumPhotos() {
		if (!this.currentAlbum) return;

		let currentAlbumPhotos = this.currentAlbum.photos;

		for (let i = 0; i < currentAlbumPhotos.length; i++) {
			currentAlbumPhotos.getItemAt(i).selected = false;
		}
	}

	unSelectAllPhotos() {
		for (let i = 0; i < this.length; i++) {
			let currentAlbumPhotos = this.getItemAt(i).photos;

			for (let j = 0; j < currentAlbumPhotos.length; j++) {
				currentAlbumPhotos.getItemAt(j).selected = false;
			}
		}
	}

	// both import paths land here : the web picker and the native one
	getServerPhotos(googlePhotos) {
		fx.service("GoogleService").fetch(googlePhotos || this.selectedPhotos);
	}

});